
export const MIN_KARMA = 300;
